
<template>
  <div class="test-result">
    <div class="result-comment fade-up">
      당신의 성향과 어울리는 색상을 찾았습니다.
    </div>
    <div class="result-comment fade-up">
      전체 참여자 중에서 <span class="percent">{{resultPercent}}%</span> 에 해당하는 색상입니다.
    </div>
    <div class="card-container" v-responsive="['hidden-all', 'md', 'lg', 'xl']">
      <div class="color-card fade-up stop-dragging" v-for="(card) in spreadSimilarColors" :key="card.hex">
        <div class="color-box stop-dragging" v-bind:style="{backgroundColor: card.hex}">
        </div>
        <div class="card-description">
          <div class="color-name only-text-dragging">
            {{card.name}}
          </div>
          <div class="color-hex only-text-dragging">
            {{card.hex}}
          </div>
        </div>
      </div>
    </div>
    <carousel class="color-card-mobile-wrapper" :perPage="1" v-responsive="['hidden-all', 'xs', 'sm']" v-if="loading" :navigateTo="2">
      <slide class="color-card-mobile fade-up stop-dragging" v-for="(card) in spreadSimilarColors" :key="card.hex">
        <div class="color-box stop-dragging" v-bind:style="{backgroundColor: card.hex}">
        </div>
        <div class="card-description">
          <div class="color-name only-text-dragging">
            {{card.name}}
          </div>
          <div class="color-hex only-text-dragging">
            {{card.hex}}
          </div>
        </div>
      </slide>
    </carousel>
    <div class="share-container">
      <img class="link-icon" src="icon_images/link_clipboard.png" alt="링크 복사하기" @click="copyToClipboard()">
      <img id="link-kakao" class="link-icon" src="icon_images/link_kakao.png" alt="카카오 공유하기" @click="sendKakaoLink()">
      <img class="link-icon" src="icon_images/link_facebook.png" alt="페이스북 공유하기" @click="sendFacebookLink()">
      <img class="link-icon" src="icon_images/link_twitter.png" alt="트위터 공유하기" @click="sendTwitterLink()">
    </div>
    <div class="restart-button button" @click="restart()">
      <v-icon name="redo-alt" scale="1.5"> </v-icon>
      <div>다시하기</div>
    </div>
    <div class="capture-button button" @click="capture()">
      <v-icon name="camera" scale="1.5"> </v-icon>
      <div>저장하기</div>
    </div>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import ColorUtil from '@/utils/ColorUtil'
import html2canvas from 'html2canvas'
import firebaseUtil from "@/firebaseUtil";

export default {
  name: 'TestResult',
  components: {
    
  },
  data() {
    return {
      output: null,
      isReadyTest: false,
      ColorUtil: ColorUtil,
      similarColors: [],
      spreadSimilarColors: [], //가운데가 메인 컬러가 오도록 펼쳐서 정렬
      loading: false,
      resultPercent: 0
    };
  },
  computed: {
    ...mapState(["chosenCards", "yourColorName", "colorDatasByName", "colorDataList"]),
    isFinishedTest() {
      return this.$route.params.color;
    }
  },
  mounted() {
    const hsv = this.yourColorHSV();
    this.similarColors = this.ColorUtil.findNearestColorList(this.colorDataList, hsv.h, hsv.s, hsv.v).slice(0, 5);
    this.spreadSimilarColors = [
      this.similarColors[3],
      this.similarColors[1],
      this.similarColors[0],
      this.similarColors[2],
      this.similarColors[4]
    ];
    this.setYourColorName(this.spreadSimilarColors[2].name);
    this.loading = true;
    document.querySelector('meta[property="og:title"]').setAttribute('content', this.yourColorName);

    const canvas = this.cardToCanvas();
    const base64image = canvas.toDataURL();
    document.querySelector('meta[property="og:image"]').setAttribute('content', this.base64image);

    const userRef = firebaseUtil.firestore().collection("statistics").doc("users");
    const testResultRef = firebaseUtil.firestore().collection("test-results").doc(this.yourColorName);

    userRef.get().then((userDoc) => {
      if (userDoc.exists) {
        testResultRef.get().then((doc) => {
            if (doc.exists && userDoc.data()["count"] > 0) {
              const percent = doc.data()["count"]/userDoc.data()["count"];
              this.resultPercent = (percent * 100).toFixed(3);
            } else {
              const percent = 1/userDoc.data()["count"];
              this.resultPercent = (percent * 100).toFixed(3);
              console.log("No such document!");
            }
        }).catch((error) => {
          console.log("Error getting document:", error);
        });
      }
    });
  },
  methods: {
    ...mapMutations(["setYourColorName"]),
    html2canvas,
    yourColorHex() {
      return this.colorDatasByName[this.$route.params.color].hex;
    },
    yourColorRGB() {
      return this.ColorUtil.hexToRgb(this.colorDatasByName[this.$route.params.color].hex);
    },
    yourColorHSV() {
      const rgb = this.yourColorRGB();
      return this.ColorUtil.rgbToHsv(rgb.r, rgb.g, rgb.b);
    },
    sendKakaoLink() {
      const file = this.cardCanvastoFile("color.png");
      console.log(file);

      Kakao.Link.uploadImage({
        file: [file]
      }).then(function(res) {
        const imageUrl = res.infos.original.url;
        Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            title: 'Color Personality',
            description: '당신의 성향에 맞는 색상을 찾아드립니다',
            imageUrl: imageUrl,
            link: {
              webUrl: `https://colorpersonality.web.app`
            },
          }
        });
      });

      // Kakao.Link.sendScrap({
      //   requestUrl: `https://colorpersonality.web.app/#/${this.yourColorName}`,
        // templateArgs: {
        //   "name": this.yourColorName,
        // }
      // });
    },
    sendFacebookLink() {
      window.open("https://www.facebook.com/sharer/sharer.php"
        +"?u="+`https://colorpersonality.web.app/#/${this.yourColorName}`);
    },
    sendTwitterLink() {
      window.open("https://twitter.com/intent/tweet"
        +"?via=kipacti"
        +"&text="+encodeURIComponent("당신의 색깔 성향을 찾아드립니다. Color Personality")
        +"&url="+`https://colorpersonality.web.app/#/${this.yourColorName}`);
    },
    copyToClipboard() {
      const createInput = document.createElement("input");
      createInput.setAttribute("type", "text");
      document.getElementById("app").appendChild(createInput);
      createInput.value = `https://colorpersonality.web.app/#/${this.yourColorName}`;
      createInput.select();
      document.execCommand('copy');
      document.getElementById("app").removeChild(createInput);
      alert('공유 링크를 복사하였습니다');
    },
    restart() {
      this.$router.replace({"name": "Home", query: {skip : true}});
      location.reload();
    },
    cardToCanvas() {
      //Draw Card Cavnas
      const ratido = 7
      const canvas = document.querySelector('#canvas');
      canvas.width = `${200*ratido}`;
      canvas.height = `${278*ratido}`;
      const ctx = canvas.getContext('2d');

      ctx.shadowColor = "#c7c7c7";
      ctx.shadowBlur = 5;
      ctx.fillStyle = "white";
      ctx.fillRect(5*ratido, 5*ratido, 190*ratido, 265*ratido);
      ctx.shadowBlur = 0;
      ctx.shadowColor = "white";

      //컬러 박스
      ctx.fillStyle = this.yourColorHex();
      ctx.fillRect(10*ratido, 10*ratido, 180*ratido, 195*ratido);

      //색상 이름
      ctx.font = `${16*ratido}px NanumSquare`;
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(this.yourColorName, canvas.width/2, 232*ratido);

      //색상코드
      ctx.font = `${15*ratido}px NanumSquare`;
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(this.yourColorHex(), canvas.width/2, 255*ratido);

      return canvas;
    },
    cardCanvastoFile(fileName){
        const canvas = this.cardToCanvas();
        const base64image = canvas.toDataURL();

        var arr = base64image.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, {type:mime});
    },
    capture() {
      const canvas = this.cardToCanvas();
      const base64image = canvas.toDataURL();
      var a = document.createElement("a"); //Create <a>
      const image = canvas.toDataURL().replace("image/png", "image/octet-stream");
      a.download = `${this.yourColorName}.png`;
      a.title = `${this.yourColorName}.png`;
      a.setAttribute("href", image);
      a.click();
    }
  },
  beforeRouteUpdate (to, from, next) {
    next();
  }
}
</script>

<style>
#canvas {
  display: none;
}
.k-progress {
  width: 45%;
}
div.k-progress-outer {
  padding-right: 0px;
}
.VueCarousel-inner{
  height: none;
}
.VueCarousel-wrapper {
  box-shadow: 0px 0px 4px 0px #efefef; 
}
.VueCarousel {
  width: 200px;
}
@media screen and (max-width: 400px) {
  .VueCarousel, .VueCarousel-inner {
    width: 150px;
  }
}
.VueCarousel-pagination > .VueCarousel-dot-container {
  /* margin-top: 0 !important; */
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.VueCarousel-dot {
  margin-top: 0px !important;
}
.VueCarousel-dot:nth-child(3) {
  width: 13px !important;
  height: 13px !important;
}
</style>
<style scoped>
.percent {
  color: crimson;
  font-weight: bold;
}
.test-result {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.link-icon {
  width: 2.4rem;
  margin: 0 4px 0 2px;
  transition-duration: 0.2s;
}
.link-icon:hover {
  cursor: pointer;
  opacity: 0.8;
}
.share-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
}
.result-comment {
  margin-bottom: 20px;
  font-size: 1.3rem;
}
.color-card {
  height: 290px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 4px 0px #efefef;
  transition-duration: 0.2s;
  padding: 5px;
  margin: 5px;
  flex-grow: 1;
  flex-basis: 100%;
  max-width: 190px;
}
.color-card-mobile {
  max-width: 200px;
  height: 290px;
  display: flex;
  flex-direction: column;
  /* box-shadow: 0px 0px 4px 0px #efefef; */
  transition-duration: 0.2s;
}
.color-card-mobile > .color-box {
  margin: 5px;
}
.color-card:nth-child(3) {
  box-shadow: 0px 0px 6px 0px #868686;
  height: 300px;
}
.color-box {
  height: 100%;
  margin: 5px;
}
.card-description {
  margin: 8px;
}
.card-description > div {
  margin: 3px;
}
.color-name {
  font-weight: bold;
}
.button {
  font-size: 1.4rem;
  background: #383838;
  color: white;
  padding: 0.5rem 0.8rem;
}
.button:hover {
  cursor: pointer;
}
.button {
  transition-duration: 0.3s;
  animation-delay: 3.8s;
}
.button:hover {
  color: black;
  background-color: white;
}
.restart-button, .capture-button{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
}
.restart-button > svg, .capture-button > svg{
  margin-right: 10px;
}
.capture-button {
  margin-top: 5px;
}
.card-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 1000px) {
  .color-card { 
    height: 260px;
    font-size: 0.8rem;
  }
    .color-card:nth-child(3) {
    height: 270px;
  }
}
@media screen and (max-width: 840px) {
  .color-card { 
    height: 240px;
    font-size: 0.7rem;
    width: 250px;
  }
  .color-card:nth-child(3) {
    height: 250px;
  }
}
@media screen and (max-width: 750px) {
  .color-card { 
    margin: 0px;
    height: 200px;
    font-size: 0.5rem;
  }
  .color-card:nth-child(3) {
    height: 210px;
  }
}

@media screen and (max-width: 600px) {
  .color-box {
    margin: 1px;
  }
  .card-description {
    margin: 3px;
  }
  .result-comment {
    font-size: 1.0rem; 
  }
  .color-card { 
    height: 170px;
    font-size: 0.2rem;
  }
  .color-card:nth-child(3) {
    height: 175px;
  }
}
@media screen and (max-width: 400px) {
  .result-comment {
    font-size: 0.8rem; 
    margin: 5px;
  }
  .color-card-mobile {
    height: 230px;
    font-size: 0.9rem;
  }
}
.result-comment.fade-up {
  animation-duration: 2s;
  animation-delay: 0.3s;
}
</style>